/**
 * Returns the first candidate that is a string with non-whitespace content.
 * Useful for alt-text chains where upstream values can be `null`, `undefined`,
 * `""`, or whitespace-only — none of which should be treated as a valid label.
 */
export const firstNonEmpty = (
  candidates: ReadonlyArray<string | null | undefined>,
  fallback: string
): string => {
  for (const value of candidates) {
    if (typeof value === "string" && value.trim().length > 0) {
      return value
    }
  }
  return fallback
}
